// extracted by mini-css-extract-plugin
export default {"bgImageWrapper":"DX5U7","picture":"GY2kB"};